// src/plugins/vuetify.js
import { createVuetify } from 'vuetify'
import { VVideo } from 'vuetify/labs/VVideo'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Opcional: define tema para mantener colores del diseñador
const theme = {
  defaultTheme: 'lightTheme',
  themes: {
    lightTheme: {
      dark: false,
      colors: {
// --tan: #d0b98a;
// --spring-wood: #f1eee5;
// --bone: #e2d7c0;
// --pavlova: #d7c4a0;
// --white-rock: #e9e3d3;

        primary: '#d0b98a',
        secondary: '#f1eee5',
        third: '#e2d7c0',
        fourth: '#d7c4a0',
        fifth: '#e9e3d3',
      },
    },
     darkTheme: {
      dark: true,
      colors: {
// --pesto: #757030;
// --costa-del-sol: #635e2e;

        primary: '#757030',
        secondary: '#514c26',
        third: '#e2d7c0',
        fourth: '#d7c4a0',
        fifth: '#e9e3d3',
      },
    },
  },
  defaults: {
    global: {
      style: {
        fontFamily: 'Inter Tight, sans-serif',
      },
    },
  },
}

export default createVuetify({
   components: {
    ...components, // incluye los componentes normales
    VVideo,        // agrega manualmente el de labs
  },
  directives,
  theme,
})
